var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import cx from "clsx";
import { ColumnType } from "./types";
import { SubCategory } from "../SubCategory";
export var Column = function (_a) {
    var children = _a.children, type = _a.type, className = _a.className;
    var isAlternative = type === ColumnType.Alternative;
    var baseClass = "md:pt-9 md:pb-16 md:pr-8 md:first:pl-10 md:last:pl-8 md:last:pr-10";
    var columnClass = cx(baseClass, className, {
        "bg-gray-50 pt-3 pb-8 md:pb-0 mt-3 md:mt-0": isAlternative,
    });
    return (React.createElement("div", { className: columnClass }, children.map(function (subCat, index) { return (React.createElement(SubCategory, __assign({}, subCat, { key: index, isAlternative: isAlternative }))); })));
};
//# sourceMappingURL=Column.js.map